import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Button,
  ButtonGroup,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import * as Fi from 'react-icons/fi';

import { Receiving, Table } from 'services/action';

const initialState = {
  showDelete: false,
  showReceive: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const StateTable = useSelector((state) => state?.Table?.data['receiving']);

  const [{ showDelete, showReceive }, setState] =
    React.useState(initialState);

  const $handleDeleteClose = () => {
    setState((prevState) => ({ ...prevState, showDelete: false }));
  };

  const $handleReceiveClose = () => {
    setState((prevState) => ({ ...prevState, showReceive: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Receiving.$delete(data?.id));
    if (del?.message === 'success') {
      $handleDeleteClose();
      Dispatch(Table.$reload('receiving', StateTable));
    }
  };

  const $handleReceive = async () => {
    const receive = await Dispatch(Receiving.$receive(data?.id));
    if (receive?.message === 'success') {
      $handleReceiveClose();
      Dispatch(Table.$reload('receiving', StateTable));
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/receiving/receive/${data?.id}`}
        >
          <Fi.FiClipboard size={15} color="#202020" className="me-2" />
          Detil
        </Link>

        {data?.document_status === 'new' && (
          <>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/receiving/receive/${data?.id}/update`}
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Perbaharui
            </Link>

            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showDelete: true }))
              }
            >
              <Fi.FiTrash2 size={15} className="me-2" />
              Hapus
            </button>

            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, showReceive: true }))
              }
            >
              <Fi.FiCheckCircle size={15} className="me-2" />
              Setujui
            </button>
          </>
        )}
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={$handleDeleteClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleDeleteClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleDeleteClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={
                  StateForm?.loading ? ' btn-loading w-100' : 'w-100'
                }
                onClick={$handleDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal Receive */}
      <Modal
        show={showReceive}
        onHide={$handleReceiveClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleReceiveClose} />
          <div className="modal-status bg-primary" />
            <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
            <h3>Anda yakin?</h3>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleReceiveClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={
                  StateForm?.loading ? ' btn-loading w-100' : 'w-100'
                }
                onClick={$handleReceive}
                disabled={StateForm?.loading}
              >
                Terima
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
};

export default Action;
